// Pantalla "Definir nueva contraseña" — se muestra cuando el usuario llega
// desde el enlace de recuperación enviado por correo. Estilo coherente con
// el Login de Aplicaciones (paleta dark).

import React, { useState } from 'react';
import { supabase } from '../supabase';

interface RecoveryPasswordProps {
  onDone: () => void;
}

export function RecoveryPassword({ onDone }: RecoveryPasswordProps) {
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [msg, setMsg] = useState('');
  const [saving, setSaving] = useState(false);

  const guardar = async () => {
    if (!password || password.length < 8) {
      setMsg('La contraseña debe tener al menos 8 caracteres.');
      return;
    }
    if (password !== password2) {
      setMsg('Las contraseñas no coinciden.');
      return;
    }
    setSaving(true);
    setMsg('');
    // Verificar sesión activa antes de updateUser
    const { data: sessionData } = await supabase.auth.getSession();
    if (!sessionData?.session) {
      setSaving(false);
      setMsg('La sesión de recuperación expiró o no se inició correctamente. Solicitá un nuevo enlace desde "¿Olvidó su contraseña?".');
      return;
    }
    const { error } = await supabase.auth.updateUser({ password });
    setSaving(false);
    if (error) {
      const m = error.message || 'No se pudo actualizar la contraseña.';
      if (m.toLowerCase().includes('session') || m.toLowerCase().includes('auth')) {
        setMsg('La sesión expiró. Solicitá un nuevo enlace y abrilo dentro de la hora.');
      } else {
        setMsg(m);
      }
      return;
    }
    setMsg('Contraseña actualizada correctamente. Ya puede iniciar sesión.');
    await supabase.auth.signOut();
    setTimeout(onDone, 1200);
  };

  return (
    <div className="login-wrap">
      <section className="login-panel-wrap" style={{ width: '100%' }}>
        <div className="login-panel">
          <div className="login-title">Definir nueva contraseña</div>
          <div className="login-sub">Recuperación de acceso · Aplicaciones MYA</div>

          <label className="field-label">Nueva contraseña</label>
          <input
            className="field-input"
            type="password"
            placeholder="Mínimo 8 caracteres"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            autoFocus
          />

          <label className="field-label">Confirmar contraseña</label>
          <input
            className="field-input"
            type="password"
            placeholder="Repita la contraseña"
            value={password2}
            onChange={(e) => setPassword2(e.target.value)}
            autoComplete="new-password"
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); guardar(); } }}
          />

          {msg && (
            <div className="login-error" style={{ color: '#cbd5e1', background: '#1e293b' }}>
              {msg}
            </div>
          )}

          <button className="btn-login" onClick={guardar} disabled={saving}>
            {saving ? 'Guardando...' : 'Actualizar contraseña'}
          </button>
          <button
            className="btn-login"
            style={{ marginTop: 8, background: '#334155' }}
            onClick={onDone}
          >
            Volver a login
          </button>
        </div>
      </section>
    </div>
  );
}

export default RecoveryPassword;
